import React, { Component } from "react";
import { getpath } from "../actions/get-path";
import { modalhandler } from "../actions/modal-handler";
import { bindActionCreators } from "redux";
import { app } from "../index";

import { connect } from "react-redux";
import {
  deleteservice,
  updateservice,
  createservice,
  feedbackHandler
} from "../services/crudservice";
import { datapop } from "../actions/data-populate";
import EmployeeManage from "../components/hr/employees";
import MaterialManage from "../components/hr/materials";
import { Tab } from "semantic-ui-react";
import SalaryCodes from "../components/hr/salaries";

import { grabservice } from "../services/crudservice";
class HRAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      materials: [],
      salarycodes: null,
      locations: null,
      resetpassmessage: false,
      accessStatus: false
    };
  }
  componentDidMount() {
    this.props.getpath("HR Admin", "smile");
    this.gensalaryoptions();
    this.genlocations();
    this.setmaterials();
  }
  componentDidUpdate(prevProps, prevState) {
    this.props.datapop("hradmin", "AccessRequest");
    console.log(this.props.params.tabindex);
    if (!this.state.materials.length) {
      this.setmaterials();
    }
  }
  gensalaryoptions() {
    grabservice("salarycodes").then(results => {
      if (results.data) {
        results = results.data;
      }
      console.log(results);
      this.setState({
        salarycodes: results
      });
    });
  }
  resetuserpassword(userid) {
    app
      .service("login")
      .patch(userid, {
        password: "edfinc",
        passwordreset: true
      })
      .then(() =>
        feedbackHandler(
          "Password Reset",
          'Password reset to "edfinc" Successfully'
        )
      );
  }
  // findaccess(userid) {
  //   return app
  //     .service("login")
  //     .find({
  //       query: {
  //         userid: userid,
  //         passwordreset: true
  //       }
  //     })
  //     .then(response => {
  //       console.log(response);
  //       if (
  //         response &&
  //         (response.length || (response.data && response.data.length))
  //       ) {
  //         this.setState({ accessStatus: true });
  //       } else {
  //         this.setState({ accessStatus: false });
  //       }
  //     });
  // }
  genlocations() {
    console.log("getting locations");
    grabservice("location").then(results => {
      console.log(results);
      if (results.data) {
        results = results.data;
      }
      this.setState({
        locations: results
      });
    });
  }
  setmaterials() {
    grabservice("materials").then(results => {
      this.setState({
        materials: results
      });
    });
  }

  render() {
    const panes = [
      {
        menuItem: "Manage Employees",
        render: () => (
          <div>
            <EmployeeManage
              employees={this.props.employees}
              jtadmins={this.props.jtadmins}
              resetpassword={userid => this.resetuserpassword(userid)}
              accessStatus={this.state.accessStatus}
              addemployee={emp => {
                console.log(emp);
                emp.userid = "xedf" + emp.empnumber;
                createservice("edfemployees", emp).then(response => {
                  // updateservice(
                  //   "edfemployees",
                  //   { ...response, userid: "xedf" + response.empnumber },
                  //   response.empnumber
                  // );
                  
                });
              }}
              handleDelete={id => {
                deleteservice("edfemployees", id);
              }}
              updateemployee={emp => {
                return updateservice("edfemployees", emp, emp.empnumber).then(
                  response => {
                    return response;
                  }
                );
              }}
            />
          </div>
        )
      },
      {
        menuItem: "Manage Materials",
        render: () => (
          <div>
            <MaterialManage
              materials={this.state.materials}
              addmaterial={mat => {
                createservice("materials", mat).then(() => this.setmaterials());
              }}
              handleDelete={matid => {
                deleteservice("materials", matid).then(() =>
                  this.setmaterials()
                );
              }}
              updatemat={mat => {
                return updateservice("materials", mat, mat.matnumber).then(() =>
                  this.setmaterials()
                );
              }}
            />
          </div>
        )
      },
      {
        menuItem: "Salary Codes",
        render: () => (
          <div>
            <SalaryCodes
              codes={this.state.salarycodes}
              locations={this.state.locations}
              disciplines={this.state.disciplines}
              addcode={code => {
                createservice("salarycodes", code).then(() =>
                  this.gensalaryoptions()
                );
              }}
              handleDelete={codeid => {
                deleteservice("salarycodes", codeid);
              }}
              updatecode={code => {
                return updateservice("salarycodes", code, code.code);
              }}
            />
          </div>
        )
      }
    ];
    const tabs = ["employees", "materials", "salaries"];
    if (this.props.employees.length) {
      //  this.props.modalhandler("none");
      return (
        <div className="HRAdmin">
          <Tab
            panes={panes}
            menu={{
              secondary: true,
              pointing: true
            }}
            defaultActiveIndex={tabs.indexOf(this.props.params.tabindex)}
            onTabChange={(e, data) => {
              console.log(data);
            }}
          />
        </div>
      );
    } else {
      return <div />;
    }
  }
}

function mapStateToProps(state) {
  return {
    fixedwods: state.workorders.fixedwods,
    wods: state.workorders.derivitives,
    customers: state.custinfo.customers,
    employees: state.employees.employees,
    jobs: state.jobs.assignedjobs,
    dates: state.dates.thisweek,
    myinfo: state.myinfo.employeeinfo
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getpath: getpath,
      datapop: datapop,
      modalhandler: modalhandler
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(HRAdmin);



// WEBPACK FOOTER //
// ./src/containers/HRAdmin.js